module.exports = __webpack_public_path__ + "static/media/discussion.6a57fc02.svg";